/**
 * The documentation constants module houses documentation-specific configurations.
 *
 * @module routes.documentation.constants
 */

angular.module('routes.documentation.constants', [])
  .config([
    '$provide',
    function ($provide) {
      'use strict';

      // Define.
      var documentation;

      // Set defaults.
      documentation = {};

      /**
       * Defines documentation constants.
       *
       * @attribute DOCUMENTATION
       * @type String
       * @readOnly
       */
      $provide.constant('DOCUMENTATION', documentation);
    }
  ]);
